/**
 * Created by fwt on 2019/4/27.
 */
import React,{Component} from "react"
import {NavBar,Modal,Toast} from 'antd-mobile';
import {invoiceBack, invoiceDetail} from "../../../service/invoiceService";
import {connect} from "react-redux";
import moment from 'moment';
import './style.less';
import { Document , Page} from 'react-pdf'
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class paperInvoice extends Component{
    constructor(props) {
        super(props);
        this.state={
            data:[],
            numPages: null,
            pageNumber: 1,
        }
    }
    componentDidMount() {
       this.getInvoiceDetail();
    }

   getInvoiceDetail(){
       let params = {
           source:1,
           token:this.props.userInfo.token,
           data:{
               id:this.props.match.params.id,
           }
       };
        Toast.loading("正在加载");
        invoiceDetail(params).then(res=>{
            if(res.data.code == "0000"){
                Toast.hide();
                this.setState({data:res.data.data,});
            }else{
                Toast.info(res.data.msg,3);
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    };
    backInvoice(){
        Toast.loading('',0);
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data: {id:this.props.match.params.id,}
        };
        invoiceBack(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.info("撤回成功",2,()=>this.props.history.goBack());
            } else {
                Toast.info(res.data.msg,3);
            }
        })
    }
    getBtn(){
        const {data} = this.state;
        if(data.status == 1 && data.invoiceType == 0){
            if(isAndroid){
                // alert('Android');
                return <div className="btn" ><a href={data.pdfUrl} >下载PDF</a></div>
            }else if(isiOS){
                // alert('iOS');
                return <div className="btn" ><a href={data.pdfUrl} >下载PDF</a></div>
                // return <div className="btn" ><a href='https://applink-party.mtime.cn/mtlf' >下载PDF</a></div>
            }
        }
        if(data.status == 0 ){
            if(data.invoiceType == 0){
                return <div className="btn"  onClick={()=>
                    Modal.alert('提示', '您确定要撤回吗?', [
                        { text: '取消'},
                        { text: '确定', onPress: () => this.backInvoice()},
                    ])}>撤回</div>
            }
            if(data.invoiceType == 1 && data.receiveType == 2 ){
                return <div className="btn"  onClick={()=>
                    Modal.alert('提示', '您确定要撤回吗?', [
                        { text: '取消'},
                        { text: '确定', onPress: () => this.backInvoice()},
                    ])}>撤回</div>
            }
        }
    }
    render() {
        const {data} = this.state;
        return (
            <div className="paperInvoice">
            {this.state.show === true ?
                <div className="bgblack" onClick={() => {this.setState({show: !this.state.show})}}>
                    <img className="img" src={data.pdfUrl}/>
                    <Document
                        className="pdf"
                        file={data.pdfUrl}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                    >
                        <Page pageNumber={this.state.pageNumber} />
                    </Document>
                </div>
                : null}

                <NavBar
                        className="navBar"
                        mode="light"
                        icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                    >
                    发票详情
                </NavBar>

                <div className="warp">
                    {/* 头部内容    */}
                    <div className="InvoiceBox">
                        <div className="content">
                            <div>发票抬头</div>
                            <div>{data.invoiceUp}</div>
                        </div>
                        <div className="content">
                            <div>发票税号</div>
                            <div>{data.invoiceNumber == "" || data.invoiceNumber == null ? "无" : data.invoiceNumber}</div>
                        </div>
                        <div className="content">
                            <div>发票类型</div>
                            <div>{data.invoiceType == 0 ? '电子发票' : '纸质发票'}  {data.invoiceType == 1  ? data.receiveType == 1 ? "邮寄" : "自提" : null}</div>
                        </div>
                        <p></p>
                        <div className="content">
                            <div>申请日期</div>
                            <div>{data.applyTimeStr}</div>
                        </div>
                        <div className="content">
                            <div>开票状态</div>
                            <span>{data.status == 1 ?  '已开票' : data.status == 0  ?  '未开票' :'待开票'}</span>
                        </div>
                        <div className="content">
                            <div>抬头类型</div>
                            <div>{data.upType == 0 ? '个人' :'企业'}</div>
                        </div>
                        <div className="content">
                            <div>发票内容</div>
                            <div>*运输服务*客运服务费用</div>
                        </div>
                        <div className="content">
                            <div>发票金额</div>
                            <div>{'¥'+data.invoiceAmount}</div>
                        </div>
                        <div className="content">
                            <div>备注信息</div>
                            <div>{data.noteResult == null ? '无' : data.noteResult}</div>
                        </div>

                         <div>
                            {
                                data.invoiceType == 0 && data.status == 1 ?
                                    <div className="viewInvoice">
                                        <a onClick={() => {this.setState({show: !this.state.show})}}>查看发票<i className="icon iconfont icontiaozhuan"/></a>
                                    </div>
                                : null
                            }
                        </div>
                    </div>
                    {
                        data.invoiceType == 0 ? (
                            <div className="info">
                                <div className="box">
                                    <div className="title">电子邮箱</div>
                                    <div className="content">{data.email}</div>
                                </div>
                                <div className="box">
                                    <div className="title">接收电话</div>
                                    <div className="content">{data.userPhone}</div>
                                </div>
                            </div>
                        ):null
                    }
                    {data.invoiceType == 1  && data.receiveType == 1 ? (
                        <div className="info">
                            <div className="box">
                                <div className="title">收&nbsp;&nbsp;件&nbsp;&nbsp;人</div>
                                <div className="content">{data.recipient}</div>
                            </div>
                            <div className="box">
                                <div className="title">联系电话</div>
                                <div className="content">{data.contactPhone}</div>
                            </div>
                            <div className="box">
                                <div className="title">收件地址</div>
                                <div className="content">{data.contactAddress}</div>
                            </div>
                            <div className="box">
                                <div className="title">快递类型</div>
                                <div className="content">{data.courierCompany}</div>
                            </div>
                            <div className="box">
                                <div className="title">快递单号</div>
                                <div className="content">{data.courierId}</div>
                            </div>
                        </div>
                    ):null}
                    {this.getBtn()}
                    {/*{
                        data.status == 1 ? (data.invoiceType == 0 ? <div className="btn"><a href={data.pdfUrl} >下载PDF</a></div> : null) :
                        (data.invoiceType == 0 ? <div className="btn"  onClick={()=>
                            Modal.alert('提示', '您确定要撤回吗?', [
                                { text: '取消'},
                                { text: '确定', onPress: () => this.backInvoice()},
                            ])}>撤回</div>  : null)
                    }*/}
                    {/*<div className="btn" onClick={()=>this.download()}>下载PDF</div>*/}
                </div>


            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Invoice/paperInvoice/index.js